import { render } from "./IconStars.vue?vue&type=template&id=24e189aa&scoped=true"
const script = {}

import "./IconStars.vue?vue&type=style&index=0&id=24e189aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e189aa"]])

export default __exports__